import React from 'react';
import styled from 'styled-components';
import {
  GateKeeperDefaultPage,
  Button,
  Title,
  Text,
  Card,
  Icon,
  theme,
} from 'components';
import { getMlsUrlsAndNames } from './constants';
import { SUPPORT_EMAIL } from '../../../utils';

const ErrorPage: React.FC<{
  mls?: string;
  title: React.ReactNode;
  description: React.ReactNode;
}> = ({ mls, title, description }) => {
  const mlsData = getMlsUrlsAndNames(mls);

  return (
    <GateKeeperDefaultPage>
      <StyledCard>
        <CardBody>
          <IconContainer>
            <Icon
              type="antdExclamationCircleFilled"
              color="primary"
              offset={[0, 1]}
            />
          </IconContainer>
          <Title level={3} textAlign="center">
            {title}
          </Title>
          <Text textAlign="center">{description}</Text>
          {mlsData && (
            <Button type="primary" href={mlsData.url}>
              Go back to {mlsData.name}
            </Button>
          )}
        </CardBody>
      </StyledCard>
    </GateKeeperDefaultPage>
  );
};

const ErrorUnverifiedUserPage: React.FC<{ mls: string }> = ({ mls }) => (
  <ErrorPage
    mls={mls}
    title={"We weren't able to log you in"}
    description={
      'You may have not been verified yet. Please contact your brokerage administration'
    }
  />
);

const ErrorListingNotFoundPage: React.FC<{
  mls: string;
  listingInfo: string;
}> = ({ mls, listingInfo }) => (
  <ErrorPage
    mls={mls}
    title={"We weren't able to provide details for this listing"}
    description={
      <>
        This listing {listingInfo} does not exist in the BrokerBay system.
        Please contact support at
        <a href={`mailto:${SUPPORT_EMAIL}`}>{` ${SUPPORT_EMAIL}`}</a>
      </>
    }
  />
);

const ErrorDashboardPrivateBrowsingPage: React.FC = () => (
  <ErrorPage
    title={"We weren't able to load the dashboard"}
    description={
      'Your experience may be impacted because you are using private mode in your internet browser. \nPlease use normal mode for the best experience.'
    }
  />
);

export {
  ErrorUnverifiedUserPage,
  ErrorListingNotFoundPage,
  ErrorDashboardPrivateBrowsingPage,
};

const IconContainer = styled.div`
  padding: 10px;
  background-color: ${theme.gray4};
  border-radius: 50%;
  width: 42px;
  height: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledCard = styled(Card)`
  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 25px;
  width: 400px;
  margin: 0 auto;
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
